import { Object, Any } from 'ts-toolbelt'
import { ValidPath } from 'ts-toolbelt/out/Function/ValidPath'

/**
 * Get a deeply nested property from an object.
 *
 * @remarks
 * Code has been lifted from https://codewithstyle.info/Deep-property-access-in-TypeScript/
 *
 * @param obj
 * @param props
 */
function getProperty<O extends object, P extends string[]>(
  obj: O,
  ...props: Any.Cast<P, ValidPath<O, P>>
): Object.Path<O, P> {
  return (
    obj &&
    props.reduce(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (result: any, prop: string) =>
        result === null || result === undefined ? undefined : result[prop],
      obj
    )
  )
}

/**
 * Get a deeply nested property from a promised object.
 *
 * @param promise - The promise that will return an object
 * @param props - Any number of property keys, that are traversed down
 *
 * @returns A promise with the property
 */
export function getPropertyFromPromisedObject<
  O extends object,
  P extends string[]
>(
  promise: Promise<O>,
  ...props: Any.Cast<P, ValidPath<O, P>>
): Promise<Object.Path<O, P>> {
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  return promise.then(obj => getProperty(obj, ...props))
}
